export default __webpack_public_path__ + "static/media/authenticator.21ffeae2.png";